import React from "react";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { useStores } from "../../stores/store";

const AdminNavbar: React.FC = () => {
	const { t } = useTranslation();
	const { auth } = useStores();

	return (
		<div className="bg-light border-right py-5 px-6 w-64 h-screen flex flex-col justify-between">

			<div>
				<div className="mb-8">
					<img alt="logo" src="/images/logo_light.png" />
				</div>
				<div className="text-white mb-4 align-middle">
					<Link to={{ pathname: `/admin/dashboard/`}}>
						<img  alt="dashboard" className="inline align-middle mr-2" src="/icons/dashboard.png" />{t('dashboard.dashboard')}
					</Link>
				</div>

				<div className="text-white mb-4 align-middle">
					<Link to={{ pathname: `/admin/institutions/`}}>
						<img  alt="institution" className="inline align-middle mr-2" src="/icons/entidashboard.png" />{t('institutions.institutions')}
					</Link>
				</div>
				
				<div className="text-white mb-4 align-middle">
					<Link to={{ pathname: `/admin/users/`}}>
						<img  alt="users" className="inline align-middle mr-2" src="/icons/userwhite.png" />{t('users.users')}
					</Link>
				</div>
			</div>

			<div>
				<div className="text-white mb-4 align-middle">
					<Link to={{ pathname: `/admin/profile/`}}>
						<img  alt="profile" className="inline align-middle mr-2" src="/icons/userwhite.png" />{auth.profile?.name}
					</Link>
				</div>

				<div className="text-white mb-4 align-middle cursor-pointer" onClick={auth.logout}>
					<img  alt="logout" className="inline align-middle mr-2" src="/icons/userwhite.png" />{t('userActions.logout')}
				</div>
			</div>

		</div>
	);
};

export default AdminNavbar;